import * as Types from './actionTypes';

export const selectProfile = profile => ({
  type: Types.SELECT,
  payload: {
    profile,
  },
});

export const profileInitialized = profile => ({
  type: Types.INITIALIZED,
  payload: {
    profile,
  },
});

export const authorize = profileId => ({
  type: Types.AUTHORIZE,
  payload: {
    profileId,
  },
});

export const update = profile => ({
  type: Types.UPDATE,
  payload: {
    profile,
  },
});
